import React from 'react';

interface FallbackProps {
  label?: string;
}

export default function Fallback(props: FallbackProps): JSX.Element {
  return (
    <div className="form-group">
      <label>{props.label}</label>
      <input
        type="text"
        disabled
        className="form-control"
        placeholder="Loading..."
      />
    </div>
  );
}
